import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/dhanu.jpg";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import pdf from "../../Assets/Ravindu Dhanushka.pdf";
import { FiArrowDownCircle } from "react-icons/fi";
import { MdOutlineLanguage } from "react-icons/md";

function HomePageBody() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Let Me <span className="purple"> Introduce </span> Myself
            </h1>
            <p className="home-about-body text-justify">
              I'm an undergraduate who is passionate about advancements in
              technology. I'm interested in creating and designing products that
              simplify daily life for people. I'm enthusiastic about exploring
              new technologies and methods within the software industry. I'm
              also skilled at quickly grasping new concepts and can easily
              adjust to various work settings.
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple">
                  {" "}
                  ASP.NET, Spring Boot, Next.js, Python and Flutter .{" "}
                </b>
              </i>
              <br />
              <Button
                variant="primary"
                href={pdf}
                target="_blank"
                style={{ maxWidth: "250px", marginTop: "20px" }}
              >
                <FiArrowDownCircle />
                &nbsp;Download CV
              </Button>
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <img
              src={myImg}
              className="img-fluid w-75 img-thumbnail"
              alt="avatar"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ravindu0823"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/RavinduDhanush4"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ravindu-dhanushka/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/_d_h_a_n_u_23/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.nsbm.ac.lk/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <MdOutlineLanguage />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default HomePageBody;
